import React, { useState, useRef, useCallback } from 'react';
import styled from 'styled-components';
import Portal from '../portal/Modal';
import { useModalStore } from './store/portal/modalStore';
import { DeviceType, ModalType } from './enum/EnumRepository';

import BulkCreateModal from '../component/work/BulkCreateModal';
import BulkCreateModalMobile from '../component/work/mobile/BulkCreateModalMobile';
import MobileConvertWrapper from './component/MobileConvertWrapper';
import { useDeviceStore } from './store/deviceStore';
import { slideInFromBottom } from './component/Animation';
import { paperTextureModal, paperTextureMobile } from './component/paperTexture';

import FullImageViewer from './component/FullImageViewer';
import Indexing from '../component/index/Indexing';
import IndexingMobile from '../component/index/mobile/IndexingMobile';
import ImportStationWorks from '../component/projectDetail/ImportStationWorks';
import ImportStationWorkMobile from '../component/projectDetail/mobile/ImportStationWorkMobile';
import ImportStationTexts from '../component/projectDetail/ImportStationTexts';
import ImportStationMobile from '../component/projectDetail/mobile/ImportStationTextMobile';
import ImportStationForTextBlock from '../component/projectDetail/ImportStationForTextBlock';
import ImportStationForTextBlockMobile from '../component/projectDetail/mobile/ImportStationForTextBlockMobile';
import ImportStationForFormationSlot from '../component/projectDetail/ImportStationForFormationSlot';
import ImportStationForFormationSlotMobile from '../component/projectDetail/mobile/ImportStationForFormationSlotMobile';
import FilterStationModal from '../component/work/FilterStationModal';
import WorkTagStationModal from '../component/work/WorkTagStationModal';
import GroupMemberTagStationModal from '../component/members/GroupMemberTagStationModal';
import TextTagStationModal from '../component/text/TextTagStationModal';
import WorkTagSelectModalMobile from '../component/work/mobile/WorkTagSelectModalMobile';
import GroupMemberLabelSelectModalMobile from '../component/members/mobile/GroupMemberLabelSelectModalMobile';
import TextTagSelectModalMobile from '../component/text/mobile/TextTagSelectModalMobile';
import CreateWorkTagModal from '../component/work/CreateWorkTagModal';
import CreateGroupMemberTagModal from '../component/members/CreateGroupMemberTagModal';
import CreateTextTagModal from '../component/text/CreateTextTagModal';
import FilterStationModalMobile from '../component/work/mobile/FilterStationModalMobile';
import QRGeneratorModal from '../component/setting/QRGeneratorModal';
import QRGeneratorModalMobile from '../component/setting/mobile/QRGeneratorModalMobile';
import AboutCvPdfModal from '../component/about/AboutCvPdfModal';
import AboutCvPdfModalMobile from '../component/about/mobile/AboutCvPdfModalMobile';
import PDFProjectStationModal from '../component/projectDetail/PDFProjectStationModal';
import PDFProjectStationModalMobile from '../component/projectDetail/mobile/PDFProjectStationModalMobile';
import FloorPlanModal from '../component/projectDetail/FloorPlanModal';
import WorkListPdfModal from '../component/work/WorkListPdfModal';
import WorkArtistSearchModal from '../component/work/WorkArtistSearchModal';
import WorkArtistSearchModalMobile from '../component/work/mobile/WorkArtistSearchModalMobile';
import ProjectInfoVenueSearchModal from '../component/projectDetail/ProjectInfoVenueSearchModal';
import ProjectInfoUrlModal from '../component/projectDetail/ProjectInfoUrlModal';
import LandingSearchModal from '../component/landing/LandingSearchModal';
import LandingSearchModalMobile from '../component/landing/mobile/LandingSearchModalMobile';

import ChangePWModal from '../component/setting/ChangePWModal';
import ChangePWModalMobile from '../component/setting/mobile/ChangePWModalMobile';
import SetPWModalMobile from '../component/setting/mobile/SetPWModalMobile';
import SetPWModal from '../component/setting/SetPWModal';
import FindPWModal from '../component/landing/FindPWModal';
import FindPWModalMobile from '../component/landing/mobile/FindPWModalMobile';
import ChangeUsernameModal from '../component/setting/ChangeUsernameModal';
import ChangeUsernameModalMobile from '../component/setting/mobile/ChangeUsernameModalMobile';
import ChangeShareModal from '../component/setting/ChangeShareModal';
import ChangeShareModalMobile from '../component/setting/mobile/ChangeShareModalMobile';
import ChangeSearchEngineModal from '../component/setting/ChangeSearchEngineModal';
import ChangeSearchEngineModalMobile from '../component/setting/mobile/ChangeSearchEngineModalMobile';
import ChangHandleModal from '../component/setting/ChangeHandleModal';
import ChangeHandleModalMobile from '../component/setting/mobile/ChangeHandleModalMobile';
import SupportModal from '../component/landing/SupportModal';
import SupportModalMobile from '../component/landing/mobile/SupportModalMobile';
import SubscriptionModal from '../component/setting/SubscriptionModal';
import SubscriptionModalMobile from '../component/setting/mobile/SubscriptionModalMobile';
import JoinWaitlistModal from '../component/setting/JoinWaitlistModal';
import JoinWaitlistModalMobile from '../component/setting/mobile/JoinWaitlistModalMobile';

import Login from '../component/auth/Login';
import LoginMobile from '../component/auth/mobile/LoginMobile';
import Register from '../component/auth/Register';
import RegisterMobile from '../component/auth/mobile/RegisterMobile';
import GroupMemberInviteModal from '../component/members/GroupMemberInviteModal';
import GroupMemberInviteModalMobile from '../component/members/mobile/GroupMemberInviteModalMobile';
import ApprovalRequestModal from '../component/setting/ApprovalRequestModal';
import ApprovalRequestModalMobile from '../component/setting/mobile/ApprovalRequestModalMobile';
import LinkedGroupMemberManagementModal from '../component/setting/LinkedGroupMemberManagementModal';
import LinkedGroupMemberManagementModalMobile from '../component/setting/mobile/LinkedGroupMemberManagementModalMobile';
import AgreePolicy from '../component/auth/AgreePolicy';
import AgreePolicyMobile from '../component/auth/mobile/AgreePolicyMobile';
import EmailVerification from '../component/auth/EmailVerification';
import EmailVerificationMobile from '../component/auth/mobile/EmailVerificationMobile';
import DeferredEmailVerification from '../component/auth/DeferredEmailVerification';
import DeferredEmailVerificationMobile from '../component/auth/mobile/DeferredEmailVerificationMobile';
import MobileOnlyWrapper from './component/MobileOnlyWrapper';

import CreateCareerMobile from '../component/about/mobile/CreateCareerMobile';
import ProjectInfoEditModalMobile from '../component/projectDetail/mobile/ProjectInfoEditModalMobile';
import CreateProjectElementMobile from '../component/projectDetail/mobile/CreateProjectElementMobile';
import { useImportStationWorkStore } from './store/importStationWorkStore';
import FilterStationMemberModal from '../admin/component/members/FilterStationMemberModal';
import FilterStationVenueModal from '../admin/component/venues/FilterStationVenueModal';
import ExhibitionFilterStationModal from '../component/exhibitions/ExhibitionFilterStationModal';
import ExhibitionFilterStationModalMobile from '../component/exhibitions/mobile/ExhibitionFilterStationModalMobile';
import ExhibitionTagSelectModalMobile from '../component/exhibitions/mobile/ExhibitionTagSelectModalMobile';
import VenueTagStationModal from '../admin/component/venues/VenueTagStationModal';
import CreateVenueTagModal from '../admin/component/venues/CreateVenueTagModal';
import ExhibitionVenueRequestModal from '../component/exhibitions/ExhibitionReqModal';
import ExhibitionVenueRequestModalMobile from '../component/exhibitions/mobile/ExhibitionReqModalMobile';
import { useStandardAlertStore } from './store/portal/alertStore';



const ModalTemplate: React.FC = () => {
  const { isClosing, standardModal, clearModal } = useModalStore();
  const {
    selectedDataList,
    formationReplacementSlotIndexes,
    clearSelectedDataList,
    clearSimpleList,
  } = useImportStationWorkStore();
  const [isUserInput, setIsUserInput] = useState(false);
  const [dragY, setDragY] = useState(0);
  const { deviceType } = useDeviceStore();
  const setUnchangedAlert = useStandardAlertStore(
    (state) => state.setUnchangedAlert,
  );

  const touchStartYRef = useRef(0);
  const dragYRef = useRef(0);

  const checkUserInputBeforeClose = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (isUserInput) {
      if (standardModal?.modalType !== ModalType.LINKED_GROUP_MEMBER_LIST) return;
      setUnchangedAlert(() => {
        setIsUserInput(false);
        if (deviceType === DeviceType.MOBILE) {
          handleCloseMobileModal();
        } else {
          clearModal();
        }
      });
      return;
    }
    if (deviceType === DeviceType.MOBILE) {
      handleCloseMobileModal();
    } else {
      clearModal();
    }
  }

  const checkUserInputBeforeCloseFloorPlan = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();
      if (isUserInput) return;
      clearModal(700);
    },
    [isUserInput, clearModal]
  );

  const handleCloseMobileModal = useCallback(() => {
    clearModal(500);
  }, [clearModal]);

  const handleImportStationOverlayClick = useCallback(() => {
    if (selectedDataList.length > 0 || formationReplacementSlotIndexes.length > 0) return;
    clearModal(700);
    clearSimpleList();
    clearSelectedDataList();
  }, [
    selectedDataList.length,
    formationReplacementSlotIndexes.length,
    clearModal,
    clearSimpleList,
    clearSelectedDataList,
  ]);

  const handleTouchStart = useCallback((e: React.TouchEvent) => {
    touchStartYRef.current = e.touches[0].clientY;
    dragYRef.current = 0;
    setDragY(0);

    const handleTouchMove = (moveEvent: TouchEvent) => {
      const deltaY = moveEvent.touches[0].clientY - touchStartYRef.current;
      if (deltaY > 0) {
        dragYRef.current = deltaY;
        setDragY(deltaY);
      }
    };

    const handleTouchEnd = () => {
      const finalDeltaY = dragYRef.current;
      const threshold = 100;

      if (finalDeltaY > threshold) {
        if (
          isUserInput
          && standardModal?.modalType === ModalType.LINKED_GROUP_MEMBER_LIST
        ) {
          setUnchangedAlert(() => {
            setIsUserInput(false);
            handleCloseMobileModal();
          });
        } else {
          handleCloseMobileModal();
        }
      }

      setDragY(0);
      dragYRef.current = 0;
      touchStartYRef.current = 0;
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };

    document.addEventListener('touchmove', handleTouchMove);
    document.addEventListener('touchend', handleTouchEnd);
  }, [handleCloseMobileModal, isUserInput, setUnchangedAlert, standardModal?.modalType]);


  if (!standardModal || standardModal.modalType === ModalType.NONE) return null;

  const renderModalContent = () => {
    switch (standardModal.modalType) {
      case ModalType.ORIGIN_IMG:
        return (
          <FullImageViewer />
        )
      case ModalType.INDEXING:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <WorkStationOverlayMobile onClick={() => clearModal(400)}>
                <ModalContentBlurMobile
                  $isClosing={isClosing}
                  onClick={(e) => e.stopPropagation()}
                >
                  <IndexingMobile />
                </ModalContentBlurMobile>
              </WorkStationOverlayMobile>
            }
            onlyNotMobileChildren={
              <WorkStationOverlay onClick={() => clearModal(400)}>
                <Indexing />
              </WorkStationOverlay>
            }
          />
        )
      case ModalType.EDIT_PROJECT_INFO_MOBILE:
        return (
          <MobileOnlyWrapper>
            <ModalOverlayMobile onClick={handleCloseMobileModal}>
              <ModalContentBlurMobile
                $isClosing={isClosing}
                onClick={(e) => e.stopPropagation()}
              >
                <ProjectInfoEditModalMobile />
              </ModalContentBlurMobile>
            </ModalOverlayMobile>
          </MobileOnlyWrapper>
        )
      case ModalType.CREATE_CAREER_MOBILE:
        return (
          <MobileOnlyWrapper>
            <WorkStationOverlayMobile onClick={() => clearModal(700)}>
              <ModalContentBlurMobile
                $isClosing={isClosing}
                onClick={(e) => e.stopPropagation()}>
                <CreateCareerMobile />
              </ModalContentBlurMobile>
            </WorkStationOverlayMobile>
          </MobileOnlyWrapper>
        )
      case ModalType.CREATE_PROJECT_ELEMENT_MOBILE:
        return (
          <MobileOnlyWrapper>
            <WorkStationOverlayMobile onClick={() => clearModal(700)}>
              <ModalContentBlurMobile
                $isClosing={isClosing}
                onClick={(e) => e.stopPropagation()}>
                <CreateProjectElementMobile />
              </ModalContentBlurMobile>
            </WorkStationOverlayMobile>
          </MobileOnlyWrapper>
        )
      case ModalType.IMPORT_STATION_WORK:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <WorkStationOverlayMobile onClick={handleImportStationOverlayClick}>
                <ModalContentBlurMobile
                  $isClosing={isClosing}
                  onClick={(e) => e.stopPropagation()}
                >
                  <ImportStationWorkMobile />
                </ModalContentBlurMobile>
              </WorkStationOverlayMobile>
            }
            onlyNotMobileChildren={
              <WorkStationOverlay onClick={handleImportStationOverlayClick}>
                <ImportStationWorks />
              </WorkStationOverlay>
            }
          />
        )
      case ModalType.IMPORT_STATION_TEXT:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <WorkStationOverlayMobile onClick={() => clearModal(700)}>
                <ModalContentBlurMobile
                  $isClosing={isClosing}
                  onClick={(e) => e.stopPropagation()}
                >
                  <ImportStationMobile />
                </ModalContentBlurMobile>
              </WorkStationOverlayMobile>
            }
            onlyNotMobileChildren={
              <WorkStationOverlay onClick={() => clearModal(700)}>
                <ImportStationTexts />
              </WorkStationOverlay>
            }
          />
        )
      case ModalType.IMPORT_STATION_FOR_TEXT_BLOCK:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <WorkStationOverlayMobile onClick={() => clearModal(700)}>
                <ModalContentBlurMobile
                  $isClosing={isClosing}
                  onClick={(e) => e.stopPropagation()}
                >
                  <ImportStationForTextBlockMobile />
                </ModalContentBlurMobile>
              </WorkStationOverlayMobile>
            }
            onlyNotMobileChildren={
              <WorkStationOverlay onClick={() => clearModal(700)}>
                <ImportStationForTextBlock />
              </WorkStationOverlay>
            }
          />
        )
      case ModalType.IMPORT_STATION_FOR_FORMATION:
      case ModalType.IMPORT_STATION_FOR_FORMATION_SLOT:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <WorkStationOverlayMobile onClick={handleImportStationOverlayClick}>
                <ModalContentBlurMobile
                  $isClosing={isClosing}
                  onClick={(e) => e.stopPropagation()}
                >
                  <ImportStationForFormationSlotMobile />
                </ModalContentBlurMobile>
              </WorkStationOverlayMobile>
            }
            onlyNotMobileChildren={
              <WorkStationOverlay onClick={handleImportStationOverlayClick}>
                <ImportStationForFormationSlot />
              </WorkStationOverlay>
            }
          />
        )
      case ModalType.WORK_TAG_STATION:
      case ModalType.GROUP_MEMBER_TAG_STATION:
      case ModalType.TEXT_TAG_STATION: {
        const TagStation =
          standardModal.modalType === ModalType.WORK_TAG_STATION
            ? WorkTagStationModal
            : standardModal.modalType === ModalType.TEXT_TAG_STATION
              ? TextTagStationModal
              : GroupMemberTagStationModal;
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <WorkStationOverlayMobile onClick={() => clearModal(700)}>
                <ModalContentBlurMobile
                  $isClosing={isClosing}
                  onClick={(e) => e.stopPropagation()}
                >
                  <TagStation
                    isMobile={true}
                    setIsUserInput={setIsUserInput}
                  />
                </ModalContentBlurMobile>
              </WorkStationOverlayMobile>
            }
            onlyNotMobileChildren={
              <WorkStationOverlay onClick={(e) => checkUserInputBeforeClose(e)}>
                <TagStation
                  isMobile={false}
                  setIsUserInput={setIsUserInput}
                />
              </WorkStationOverlay>
            }
          />
        )
      }
      case ModalType.VENUE_TAG_STATION:
        return (
          <WorkStationOverlay onClick={checkUserInputBeforeClose}>
            <VenueTagStationModal setIsUserInput={setIsUserInput} />
          </WorkStationOverlay>
        )
      case ModalType.SELECT_WORK_TAG_MOBILE:
        return (
          <MobileOnlyWrapper>
            <WorkStationOverlayMobile onClick={() => clearModal(700)}>
              <ModalContentBlurMobile
                $isClosing={isClosing}
                onClick={(e) => e.stopPropagation()}
              >
                <WorkTagSelectModalMobile />
              </ModalContentBlurMobile>
            </WorkStationOverlayMobile>
          </MobileOnlyWrapper>
        )
      case ModalType.SELECT_EXHIBITION_TAG_MOBILE:
        return (
          <MobileOnlyWrapper>
            <WorkStationOverlayMobile onClick={() => clearModal(700)}>
              <ModalContentBlurMobile
                $isClosing={isClosing}
                onClick={(e) => e.stopPropagation()}
              >
                <ExhibitionTagSelectModalMobile />
              </ModalContentBlurMobile>
            </WorkStationOverlayMobile>
          </MobileOnlyWrapper>
        )
      case ModalType.SELECT_GROUP_MEMBER_TAG_MOBILE:
        return (
          <MobileOnlyWrapper>
            <WorkStationOverlayMobile onClick={() => clearModal(700)}>
              <ModalContentBlurMobile
                $isClosing={isClosing}
                onClick={(e) => e.stopPropagation()}
              >
                <GroupMemberLabelSelectModalMobile />
              </ModalContentBlurMobile>
            </WorkStationOverlayMobile>
          </MobileOnlyWrapper>
        )
      case ModalType.SELECT_TEXT_TAG_MOBILE:
        return (
          <MobileOnlyWrapper>
            <WorkStationOverlayMobile onClick={() => clearModal(700)}>
              <ModalContentBlurMobile
                $isClosing={isClosing}
                onClick={(e) => e.stopPropagation()}
              >
                <TextTagSelectModalMobile />
              </ModalContentBlurMobile>
            </WorkStationOverlayMobile>
          </MobileOnlyWrapper>
        )
      case ModalType.CREATE_WORK_TAG:
      case ModalType.CREATE_GROUP_MEMBER_TAG:
      case ModalType.CREATE_TEXT_TAG: {
        const CreateTagModal =
          standardModal.modalType === ModalType.CREATE_WORK_TAG
            ? CreateWorkTagModal
            : standardModal.modalType === ModalType.CREATE_TEXT_TAG
              ? CreateTextTagModal
              : CreateGroupMemberTagModal;
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <ModalOverlayMobile onClick={(e) => checkUserInputBeforeClose(e)}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <CreateTagModal
                    isMobile={true}
                    setIsUserInput={setIsUserInput}
                  />
                </ModalContentMobile>
              </ModalOverlayMobile>
            }
            onlyNotMobileChildren={
              <ModalOverlayBrighter onClick={checkUserInputBeforeClose}>
                <CreateTagModal
                  isMobile={false}
                  setIsUserInput={setIsUserInput}
                />
              </ModalOverlayBrighter>
            }
          />
        )
      }
      case ModalType.CREATE_VENUE_TAG:
        return (
          <ModalOverlayBrighter onClick={checkUserInputBeforeClose}>
            <CreateVenueTagModal setIsUserInput={setIsUserInput} />
          </ModalOverlayBrighter>
        )
      case ModalType.FILTER_STATION:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <WorkStationOverlayMobile onClick={() => clearModal(700)}>
                <ModalContentBlurMobile
                  $isClosing={isClosing}
                  onClick={(e) => e.stopPropagation()}
                >
                  <FilterStationModalMobile />
                </ModalContentBlurMobile>
              </WorkStationOverlayMobile>
            }
            onlyNotMobileChildren={
              <WorkStationOverlay onClick={() => clearModal(700)}>
                <FilterStationModal />
              </WorkStationOverlay>
            }
          />
        )
      case ModalType.FILTER_STATION_MEMBER:
        return (
              <WorkStationOverlay onClick={() => clearModal(700)}>
                <FilterStationMemberModal />
              </WorkStationOverlay>
        )
      case ModalType.FILTER_STATION_VENUE:
        return (
              <WorkStationOverlay onClick={() => clearModal(700)}>
                <FilterStationVenueModal />
              </WorkStationOverlay>
        )
      case ModalType.FILTER_STATION_EXHIBITION:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <WorkStationOverlayMobile onClick={() => clearModal(700)}>
                <ModalContentBlurMobile
                  $isClosing={isClosing}
                  onClick={(e) => e.stopPropagation()}
                >
                  <ExhibitionFilterStationModalMobile />
                </ModalContentBlurMobile>
              </WorkStationOverlayMobile>
            }
            onlyNotMobileChildren={
              <WorkStationOverlay onClick={() => clearModal(700)}>
                <ExhibitionFilterStationModal />
              </WorkStationOverlay>
            }
          />
        )
      case ModalType.CREATE_PROJECT_PDF:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <WorkStationOverlayMobile onClick={() => clearModal(700)}>
                <ModalContentBlurMobile
                  $isClosing={isClosing}
                  onClick={(e) => e.stopPropagation()}>
                  <PDFProjectStationModalMobile />
                </ModalContentBlurMobile>
              </WorkStationOverlayMobile>
            }
            onlyNotMobileChildren={
              <WorkStationOverlay onClick={() => clearModal(700)}>
                <PDFProjectStationModal />
              </WorkStationOverlay>
            }
          />
        )
      case ModalType.QR_GENERATOR:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <WorkStationOverlayMobile onClick={() => clearModal(700)}>
                <ModalContentBlurMobile
                  $isClosing={isClosing}
                  onClick={(e) => e.stopPropagation()}
                >
                  <QRGeneratorModalMobile />
                </ModalContentBlurMobile>
              </WorkStationOverlayMobile>
            }
            onlyNotMobileChildren={
              <WorkStationOverlay onClick={() => clearModal(700)}>
                <QRGeneratorModal />
              </WorkStationOverlay>
            }
          />
        )
      case ModalType.CREATE_WORK_PDF:
        return (
          <WorkStationOverlay onClick={checkUserInputBeforeCloseFloorPlan}>
            <WorkListPdfModal setIsUserInput={setIsUserInput} />
          </WorkStationOverlay>
        )
      case ModalType.CREATE_ABOUT_PDF:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <WorkStationOverlayMobile onClick={() => clearModal(700)}>
                <ModalContentBlurMobile
                  $isClosing={isClosing}
                  onClick={(e) => e.stopPropagation()}
                >
                  <AboutCvPdfModalMobile />
                </ModalContentBlurMobile>
              </WorkStationOverlayMobile>
            }
            onlyNotMobileChildren={
              <WorkStationOverlay onClick={() => clearModal(700)}>
                <AboutCvPdfModal />
              </WorkStationOverlay>
            }
          />
        )
      case ModalType.CREATE_FLOOR_PLAN:
        return (
          <WorkStationOverlay onClick={checkUserInputBeforeCloseFloorPlan}>
            <FloorPlanModal setIsUserInput={setIsUserInput} />
          </WorkStationOverlay>
        )
      case ModalType.CHANGE_PW:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <ModalOverlayMobile onClick={(e) => checkUserInputBeforeClose(e)}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <ChangePWModalMobile setIsUserInput={setIsUserInput} />
                </ModalContentMobile>
              </ModalOverlayMobile>
            }
            onlyNotMobileChildren={
              <ModalOverlayBrighter onClick={checkUserInputBeforeClose}>
                <ChangePWModal setIsUserInput={setIsUserInput} />
              </ModalOverlayBrighter>
            }
          />
        )
      case ModalType.SET_PW:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <ModalOverlayMobile onClick={(e) => checkUserInputBeforeClose(e)}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <SetPWModalMobile setIsUserInput={setIsUserInput} />
                </ModalContentMobile>
              </ModalOverlayMobile>
            }
            onlyNotMobileChildren={
              <ModalOverlayBrighter onClick={checkUserInputBeforeClose}>
                <SetPWModal setIsUserInput={setIsUserInput} />
              </ModalOverlayBrighter>
            }
          />
        )
      case ModalType.FIND_PW:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <ModalOverlayMobile onClick={(e) => checkUserInputBeforeClose(e)}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <FindPWModalMobile setIsUserInput={setIsUserInput} />
                </ModalContentMobile>
              </ModalOverlayMobile>
            }
            onlyNotMobileChildren={
              <ModalOverlayBrighter onClick={checkUserInputBeforeClose}>
                <FindPWModal setIsUserInput={setIsUserInput} />
              </ModalOverlayBrighter>
            }
          />
        )
      case ModalType.CHANGE_HANDLE:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <ModalOverlayMobile onClick={(e) => checkUserInputBeforeClose(e)}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <ChangeHandleModalMobile setIsUserInput={setIsUserInput} />
                </ModalContentMobile>
              </ModalOverlayMobile>
            }
            onlyNotMobileChildren={
              <ModalOverlayBrighter onClick={checkUserInputBeforeClose}>
                <ChangHandleModal setIsUserInput={setIsUserInput} />
              </ModalOverlayBrighter>
            }
          />
        )
      case ModalType.CHANGE_USERNAME:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <ModalOverlayMobile onClick={(e) => checkUserInputBeforeClose(e)}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <ChangeUsernameModalMobile setIsUserInput={setIsUserInput} />
                </ModalContentMobile>
              </ModalOverlayMobile>
            }
            onlyNotMobileChildren={
              <ModalOverlayBrighter onClick={checkUserInputBeforeClose}>
                <ChangeUsernameModal setIsUserInput={setIsUserInput} />
              </ModalOverlayBrighter>
            }
          />
        )
      case ModalType.CHANGE_SHARE:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <WorkStationOverlayMobile onClick={(e) => checkUserInputBeforeClose(e)}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <ChangeShareModalMobile setIsUserInput={setIsUserInput} />
                </ModalContentMobile>
              </WorkStationOverlayMobile>
            }
            onlyNotMobileChildren={
              <WorkStationOverlay onClick={checkUserInputBeforeClose}>
                <ChangeShareModal setIsUserInput={setIsUserInput} />
              </WorkStationOverlay>
            }
          />
        )
      case ModalType.CHANGE_SEARCH_ENGINE:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <WorkStationOverlayMobile onClick={(e) => checkUserInputBeforeClose(e)}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <ChangeSearchEngineModalMobile setIsUserInput={setIsUserInput} />
                </ModalContentMobile>
              </WorkStationOverlayMobile>
            }
            onlyNotMobileChildren={
              <WorkStationOverlay onClick={checkUserInputBeforeClose}>
                <ChangeSearchEngineModal setIsUserInput={setIsUserInput} />
              </WorkStationOverlay>
            }
          />
        )
      case ModalType.SUPPORT:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <ModalOverlayMobile onClick={(e) => checkUserInputBeforeClose(e)}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <SupportModalMobile setIsUserInput={setIsUserInput} />
                </ModalContentMobile>
              </ModalOverlayMobile>
            }
            onlyNotMobileChildren={
              <ModalOverlayBrighter onClick={checkUserInputBeforeClose}>
                <SupportModal setIsUserInput={setIsUserInput} />
              </ModalOverlayBrighter>
            }
          />
        )
      case ModalType.VENUE_REQUEST:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <ModalOverlayMobile onClick={(e) => checkUserInputBeforeClose(e)}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <ExhibitionVenueRequestModalMobile setIsUserInput={setIsUserInput} />
                </ModalContentMobile>
              </ModalOverlayMobile>
            }
            onlyNotMobileChildren={
              <ModalOverlayBrighter onClick={checkUserInputBeforeClose}>
                <ExhibitionVenueRequestModal setIsUserInput={setIsUserInput} />
              </ModalOverlayBrighter>
            }
          />
        )
      case ModalType.SUBSCRIPTION:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <ModalOverlayMobile onClick={(e) => checkUserInputBeforeClose(e)}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <SubscriptionModalMobile />
                </ModalContentMobile>
              </ModalOverlayMobile>
            }
            onlyNotMobileChildren={
              <ModalOverlayBrighter onClick={checkUserInputBeforeClose}>
                <SubscriptionModal />
              </ModalOverlayBrighter>
            }
          />
        )
      case ModalType.BULK_UPLOAD:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <WorkStationOverlayMobile onClick={() => clearModal(700)}>
                <ModalContentBlurMobile
                  $isClosing={isClosing}
                  onClick={(e) => e.stopPropagation()}
                >
                  <BulkCreateModalMobile />
                </ModalContentBlurMobile>
              </WorkStationOverlayMobile>
            }
            onlyNotMobileChildren={
              <ModalOverlayBrighter onClick={checkUserInputBeforeClose}>
                <BulkCreateModal />
              </ModalOverlayBrighter>
            }
          />
        )
      case ModalType.JOIN_WAITLIST:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <ModalOverlayMobile onClick={(e) => checkUserInputBeforeClose(e)}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <JoinWaitlistModalMobile />
                </ModalContentMobile>
              </ModalOverlayMobile>
            }
            onlyNotMobileChildren={
              <ModalOverlayBrighter onClick={checkUserInputBeforeClose}>
                <JoinWaitlistModal />
              </ModalOverlayBrighter>
            }
          />
        )
      case ModalType.LOGIN:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <ModalOverlayMobile onClick={(e) => checkUserInputBeforeClose(e)}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <LoginMobile setIsUserInput={setIsUserInput} />
                </ModalContentMobile>
              </ModalOverlayMobile>
            }
            onlyNotMobileChildren={
              <ModalOverlay onClick={checkUserInputBeforeClose}>
                <ModalContent onClick={(e) => e.stopPropagation()}>
                  <Login setIsUserInput={setIsUserInput} />
                </ModalContent>
              </ModalOverlay>
            }
          />
        )
      case ModalType.REGISTER:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <ModalOverlayMobile onClick={(e) => checkUserInputBeforeClose(e)}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <RegisterMobile setIsUserInput={setIsUserInput} />
                </ModalContentMobile>
              </ModalOverlayMobile>
            }
            onlyNotMobileChildren={
              <ModalOverlay onClick={checkUserInputBeforeClose}>
                <ModalContent onClick={(e) => e.stopPropagation()}>
                  <Register setIsUserInput={setIsUserInput} />
                </ModalContent>
              </ModalOverlay>
            }
          />
        )
      case ModalType.GROUP_MEMBER_INVITE:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <ModalOverlayMobile onClick={checkUserInputBeforeClose}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <GroupMemberInviteModalMobile setIsUserInput={setIsUserInput} />
                </ModalContentMobile>
              </ModalOverlayMobile>
            }
            onlyNotMobileChildren={
              <ModalOverlay onClick={checkUserInputBeforeClose}>
                <ModalContent onClick={(e) => e.stopPropagation()}>
                  <GroupMemberInviteModal setIsUserInput={setIsUserInput} />
                </ModalContent>
              </ModalOverlay>
            }
          />
        )
      case ModalType.APPROVAL_REQUEST_LIST:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <ModalOverlayMobile onClick={handleCloseMobileModal}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <ApprovalRequestModalMobile />
                </ModalContentMobile>
              </ModalOverlayMobile>
            }
            onlyNotMobileChildren={
              <ModalOverlay onClick={() => clearModal()}>
                <ApprovalRequestModal />
              </ModalOverlay>
            }
          />
        )
      case ModalType.LINKED_GROUP_MEMBER_LIST:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <ModalOverlayMobile onClick={checkUserInputBeforeClose}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <LinkedGroupMemberManagementModalMobile
                    setIsUserInput={setIsUserInput}
                  />
                </ModalContentMobile>
              </ModalOverlayMobile>
            }
            onlyNotMobileChildren={
              <ModalOverlay onClick={checkUserInputBeforeClose}>
                <LinkedGroupMemberManagementModal setIsUserInput={setIsUserInput} />
              </ModalOverlay>
            }
          />
        )
      case ModalType.WORK_ARTIST_SEARCH:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <ModalOverlayMobile onClick={handleCloseMobileModal}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <WorkArtistSearchModalMobile />
                </ModalContentMobile>
              </ModalOverlayMobile>
            }
            onlyNotMobileChildren={
              <ModalOverlay onClick={() => clearModal()}>
                <ModalContent onClick={(e) => e.stopPropagation()}>
                  <WorkArtistSearchModal />
                </ModalContent>
              </ModalOverlay>
            }
          />
        )
      case ModalType.PROJECT_INFO_VENUE_SEARCH:
      case ModalType.PROJECT_INFO_URL: {
        if (deviceType === DeviceType.MOBILE) return null;

        const isUrlModal = standardModal.modalType === ModalType.PROJECT_INFO_URL;
        const projectInfoModal = isUrlModal
          ? <ProjectInfoUrlModal setIsUserInput={setIsUserInput} />
          : <ProjectInfoVenueSearchModal />;
        return (
          <ModalOverlay onClick={isUrlModal ? checkUserInputBeforeClose : () => clearModal()}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
              {projectInfoModal}
            </ModalContent>
          </ModalOverlay>
        )
      }
      case ModalType.LANDING_MEMBER_SEARCH:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <ModalOverlayMobile onClick={handleCloseMobileModal}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <LandingSearchModalMobile />
                </ModalContentMobile>
              </ModalOverlayMobile>
            }
            onlyNotMobileChildren={
              <ModalOverlay onClick={() => clearModal()}>
                <ModalContent onClick={(e) => e.stopPropagation()}>
                  <LandingSearchModal />
                </ModalContent>
              </ModalOverlay>
            }
          />
        )
      case ModalType.AGREE_POLICY:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <ModalOverlayMobile onClick={handleCloseMobileModal}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <AgreePolicyMobile setIsUserInput={setIsUserInput} />
                </ModalContentMobile>
              </ModalOverlayMobile>
            }
            onlyNotMobileChildren={
              <ModalOverlay onClick={checkUserInputBeforeClose}>
                <ModalContent onClick={(e) => e.stopPropagation()}>
                  <AgreePolicy setIsUserInput={setIsUserInput} />
                </ModalContent>
              </ModalOverlay>
            }
          />
        )
      case ModalType.VERIFICATION:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <ModalOverlayMobile onClick={(e) => checkUserInputBeforeClose(e)}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <EmailVerificationMobile setIsUserInput={setIsUserInput} />
                </ModalContentMobile>
              </ModalOverlayMobile>
            }
            onlyNotMobileChildren={
              <ModalOverlay onClick={checkUserInputBeforeClose}>
                <ModalContent onClick={(e) => e.stopPropagation()}>
                  <EmailVerification setIsUserInput={setIsUserInput} />
                </ModalContent>
              </ModalOverlay>
            }
          />
        )
      case ModalType.DEFERRED_EMAIL_VERIFICATION:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={
              <ModalOverlayMobile onClick={(e) => checkUserInputBeforeClose(e)}>
                <ModalContentMobile
                  $isClosing={isClosing}
                  $dragY={dragY}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={handleTouchStart}
                >
                  <DeferredEmailVerificationMobile setIsUserInput={setIsUserInput} />
                </ModalContentMobile>
              </ModalOverlayMobile>
            }
            onlyNotMobileChildren={
              <ModalOverlay onClick={checkUserInputBeforeClose}>
                <ModalContent onClick={(e) => e.stopPropagation()}>
                  <DeferredEmailVerification setIsUserInput={setIsUserInput} />
                </ModalContent>
              </ModalOverlay>
            }
          />)
      default:
        return null;
    }
  };

  return (
    <Portal>
      {renderModalContent()}
    </Portal>
  );
};


const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.color_Alpha_02};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10; /* 햄버거 메뉴(6) 위에 표시 */
`;

const ModalOverlayMobile = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.color_Alpha_02};
  display: flex;
  justify-content: center;
  align-items: flex-end;
  backdrop-filter: blur(4px);
  z-index: 10; /* 햄버거 메뉴(6) 위에 표시 */
`;

const ModalOverlayBrighter = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.color_Alpha_03};
  display: flex;
  justify-content: center;
  align-items: center;

  z-index: 10; /* 햄버거 메뉴(6) 위에 표시 */
`;

const ModalContent = styled.div`
  position: relative;
  width: 480px;
  padding: 20px;
  ${paperTextureModal}
  background-color: ${({ theme }) => theme.colors.color_White};
`;

const ModalContentMobile = styled.div<{ $isClosing: boolean; $dragY: number }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 20px;
  transform: ${({ $isClosing, $dragY }) =>
    $isClosing
      ? 'translateY(100%)'
      : `translateY(${$dragY}px)`
  };
  transition: ${({ $dragY }) => ($dragY > 0 ? 'none' : 'all 0.5s ease-out')};
  ${paperTextureMobile}
  background-color: ${({ theme }) => theme.colors.color_White};
  ${slideInFromBottom}
`;

const ModalContentBlurMobile = styled.div<{ $isClosing: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 20px;

  transform: ${({ $isClosing }) =>
    $isClosing
      ? 'translateY(100%)'
      : 'translateY(0)'
  };
  transition: all 0.5s ease-out;
  
  overflow: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  ${paperTextureMobile}
  background-color: ${({ theme }) => theme.colors.color_White};
  ${slideInFromBottom}
`;

const WorkStationOverlay = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;

  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;

  z-index: 10; /* 햄버거 메뉴(6) 위에 표시 */
`;

const WorkStationOverlayMobile = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;

  display: flex;
  width: 100%;
  height: 100%;
  align-items: flex-end;
  background-color: ${({ theme }) => theme.colors.color_Alpha_02};

  z-index: 10; /* 햄버거 메뉴(6) 위에 표시 */
`;

export default ModalTemplate;
